module.exports = __webpack_public_path__ + "img/logo30.9c3f9de5.png";